import { Main } from "../components/examination-inquiry/Main";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/**
 * 審査内容照会
 */
const ExaminationInquiry = () => {
  useAuthenticationHook(PERMISSIONS.EXAMINE);
  return <Main />;
};

export default ExaminationInquiry;
